import jsonStringify from 'json-stringify-safe';
import { Helmet } from 'react-helmet-async';

export const SearchboxStartpageMetadata: React.FC = () => {
  const sitelinkSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://www.xing.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate:
          'https://www.xing.com/jobs/search?keywords={search_term_string}',
      },
      'query-input': 'required name={search_term_string}',
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">
        {jsonStringify(sitelinkSchema)}
      </script>
    </Helmet>
  );
};
